import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const PressKitsStyles = styled.div`
  padding-top: 55px;
  .branding-section {
    margin-bottom: 100px;

    & > h3 {
      border-bottom: 1px solid ${Colors.accent.grey5.standard};
      padding-bottom: 10px;
    }

    & a:link,
    a:visited,
    a:hover,
    a:active {
      color: ${Colors.primary.claytonBlue.standard};
      text-decoration: none;
    }
  }

  .branding-actions {
    display: flex;
    justify-content: center;
    margin-top: -50px;
  }

  @media only screen and (min-width: ${desktop_breakpoint}px) {
    .branding-cards {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;

      .empty {
        width: calc((100% - 25px) / 2);
      }
    }

    .resources-cards {
      .empty {
        width: calc((100% - 25px) / 4);
      }
    }
  }
`;

export default PressKitsStyles;
